import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {SVGIcon} from '../../ui/SVGIcon/SVGIcon';
import styles from './ShareButton.scss';
import {SvgComponent} from '../../../reactDomTypes';

interface Props {
  iconSvg: SvgComponent;
  className?: string;
  accName?: string;
  onClick?: React.MouseEventHandler;
  onKeyDown?: React.KeyboardEventHandler;
  tabIndex?: number;
  dataHook?: string;
}

export const ShareButton: React.FC<Props> = ({iconSvg, className, accName, onClick, onKeyDown, tabIndex, dataHook}) => (
  <button
    className={classnames(className, styles.shareButton)}
    data-hook={dataHook}
    aria-label={accName}
    tabIndex={tabIndex}
    onKeyDown={onKeyDown}
    onClick={onClick}
  >
    <SVGIcon Svg={iconSvg} accHidden />
  </button>
);

ShareButton.propTypes = {
  iconSvg: PropTypes.any.isRequired,
  accName: PropTypes.string,
  tabIndex: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  dataHook: PropTypes.string,
};

ShareButton.defaultProps = {
  dataHook: 'social-share-service-button',
};

ShareButton.displayName = 'ShareButton';
